import { render, staticRenderFns } from "./DlgEventGuestDelete.vue?vue&type=template&id=197028f5&scoped=true"
import script from "./DlgEventGuestDelete.vue?vue&type=script&lang=ts"
export * from "./DlgEventGuestDelete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197028f5",
  null
  
)

export default component.exports